import { useQuery } from '@tanstack/react-query';
import API from '../context/API';

export interface MerchantData {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  devices?: any[];
  currentSessions?: any[];
  [key: string]: any;
}

export const MERCHANT_DATA_QUERY_KEY = ['merchant', 'profile'] as const;

// Shared across Dashboard, DashboardManager and Merchants — anywhere that
// needs the logged-in merchant's own profile. Only the 'merchant' role has
// a profile at this endpoint, so other roles (manager/staff/admin) skip the
// request entirely instead of hitting a guaranteed 401/403.
export const useMerchantData = () => {
  const role = localStorage.getItem('role');

  return useQuery<MerchantData>({
    queryKey: MERCHANT_DATA_QUERY_KEY,
    queryFn: async () => {
      const token = localStorage.getItem('access_token');
      const res = await API.get('merchant/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.data;
    },
    enabled: role === 'merchant',
    staleTime: 60_000,
  });
};
